import { render, staticRenderFns } from "./course-plate.vue?vue&type=template&id=059a2ef2&scoped=true&"
import script from "./course-plate.vue?vue&type=script&lang=js&"
export * from "./course-plate.vue?vue&type=script&lang=js&"
import style0 from "./course-plate.vue?vue&type=style&index=0&id=059a2ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a2ef2",
  null
  
)

export default component.exports